<template>
    <div>
      <div class="specialties-section" v-show="location.specialties.length > 0">
        <span><hp5-heading size-selection="xxs" tag-selection="h4">Specialties: </hp5-heading></span>
        <span class="item" v-for="(specialty, index) in showSpecialties(isActive)" :key="index"> {{ specialty }}</span>
        <a
          tabindex="0"
          :data-card-rank="rank"
          v-show="location.specialties.length > 3"
          v-on:click.stop.self.prevent="isActive = !isActive"
          v-on:keydown.enter.prevent="isActive = !isActive"
          v-on:keydown.space.prevent="isActive = !isActive"
          class="showmore"
          :class="isActive ? `hide` : ''"
        >
          + {{ location.specialties.length - 3 }} more
        </a>
      </div>
    </div>
</template>
<script setup>

    const props = defineProps({
        location: Object,
        rank: Number
    })
  
    const isActive = ref(false)
  
    const displayList = (items) => {
        return items.map((item, index) => {
            return index < items.length - 1 ? `${item}, ` : item
        })
    }
  
    const showSpecialties = (showmore) => {
        if (showmore) return displayList(props.location.specialties)
        else if (props.location.specialties.length > 1) return displayList(props.location.specialties.slice(0, 3))
        else return displayList(props.location.specialties)
    }
  
</script>
  
<style lang="scss" scoped>
  .schedulingPatients {
    display: flex;
    align-items: center;
  }
  
  hp5-heading,
  h3 {
    display: inline-block;
  }
  
  span {
    //display: inline-block;
    line-height: var(--text-heading-line-height-xs);
    font-weight: var(--text-body-weight-xs);
    font-size: var(--text-body-pixels-xs);
  }
  
  hp5-heading {
    margin-right: var(--spacing-xxs);
  }
  .specialties-section {
    display: inline-block;
    font-family: var(--text-heading-font-xs);
    font-size: var(--text-heading-pixels-xs);
    line-height: var(--text-heading-line-height-xs);
    letter-spacing: var(--text-heading-letter-spacing-xs);
  }
  
  .showmore {
    margin-left: var(--spacing-xs);
    vertical-align: top;
    cursor: pointer;
    color: var(--color-link-base);
    font-family: var(--text-body-font-xs);
    font-weight: var(--text-body-weight-xs);
    font-size: var(--text-body-pixels-xs);
    line-height: var(--text-body-line-height-xs);
    letter-spacing: var(--text-body-letter-spacing-xs);
    font-weight: inherit;
    text-decoration: underline;
  }
  
  .hide {
    display: none;
  }
</style>